import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    defaultMessage: 'International Address Mismatch',
    id: 'gxMXgC',
    description: 'Title for international address mismatch card',
  },
  description: {
    defaultMessage:
      'Flags orders where the billing country differs from the shipping country. This detects a common fraud pattern where stolen credit cards are used to ship goods internationally to reshipping addresses.',
    id: 'VkDrfl',
    description: 'Description of international address mismatch detection',
  },
});
